<template>
    <div v-if="isCabinetReady">
        <cabinet-notification />
        <router-view />
    </div>
    <cabinet-loading v-else />
</template>

<script>
    import Loading from '@/containers/Loading.vue'
    import Toastr from 'vue-toastr'

    export default {
        name: 'app',
        components: {
            'cabinet-loading': Loading,
            'cabinet-notification': Toastr
        },
        data () {
            return {
                ready: false
            }
        },
        computed: {
            isCabinetReady () {
                return this.$auth.ready() && this.ready
            }
        },
        mounted () {
            this.refresh()

            setTimeout(() => {
                this.ready = true
            }, 100)
        },
        methods: {
            refreshRate () {
                if (this.$auth.check()) {
                    this.$store.dispatch('refreshRate')
                }
            },
            refreshUserdata () {
                if (this.$auth.check()) {
                    this.$store.dispatch('refreshUserdata')
                }
            },
            refresh () {
                this.refreshRate()
                this.refreshUserdata()

                let updateTime = 100

                if (this.$auth.check()) {
                    updateTime *= 200
                }

                setTimeout(() => {
                    this.refresh()
                }, updateTime)
            }
        }
    }
</script>

<style lang="scss">
    /* Import Font Awesome Icons Set */
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/css/font-awesome.min.css';
    /* Import Simple Line Icons Set */
    $simple-line-font-path: '~simple-line-icons/fonts/';
    @import '~simple-line-icons/css/simple-line-icons.css';
    /* Import Bootstrap Vue Styles */
    @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
    // Import Main styles for this application
    @import './scss/style';

    body {
        background-color: rgb(240, 240, 240);
        color: rgb(90, 90, 90);
        font-size: 1em;
    }

    .app-header.navbar .navbar-brand {
        background-size: 160px auto;
    }
</style>



// WEBPACK FOOTER //
// App.vue?2e511d0e